export const PageLoader = () => (
  <div className="min-h-screen bg-black grid place-items-center" role="status" aria-live="polite" data-testid="page-loader">
    <div className="flex items-center gap-2">
      {[0, 150, 300].map((d) => (
        <span key={d} className="w-2.5 h-2.5 rounded-full animate-pulse" style={{ background: "#FFDA7C", animationDelay: `${d}ms` }} />
      ))}
    </div>
    <span className="sr-only">Loading page</span>
  </div>
);
